import { Component, OnInit, Output,EventEmitter, Input } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { RestapiService } from '../services/restapi.service';
import amplitude from 'amplitude-js';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.css']
})
export class TopNavbarComponent implements OnInit {

  @Output() sideNavToggled = new EventEmitter<boolean>();
  @Input() InputInfoArray = [];
  menuStatus:boolean=false;

  public navMenu: boolean;
  public supportMenu: boolean;
  public salesMenu: boolean;
  public docMenu: boolean;

  public scaleCount: string = '';
  public feedBackDescription: string = '';
  public email: string = '';
  public contactPersmission: boolean = true;
  public buttonArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  toggle: boolean = true;
  showScale: boolean = false;
  showDescription: boolean = false;
  showEmail: boolean = false;
  feedbackSubmitted: boolean = true;
  contactPerson = 'No';
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");



  constructor(public googleAnalyticsService: GoogleAnalyticsService,
    private apiService: RestapiService) { }

  ngOnInit(): void {
  }

  resetValues(){
    this.showScale = false;
    this.showDescription = false;
    this.showEmail = false;
    this.scaleCount='';
    this.email = '';
    this.feedBackDescription='';
    this.contactPersmission = true;
    this.contactPerson = 'No';
  }

  openModal(modalType) {
    this.resetValues();
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'block';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'block';
  }

  closeModal(modalType) {
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'none';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'none';
    this.resetValues();
  }

  submitFeedback() {
    console.log('submitFeedback : ');
   
    
    if (this.contactPersmission) {
      this.contactPerson = 'Yes'
    }

       
    if (this.scaleCount === '') {
      this.showScale = true;
      
    }else{
      this.showScale = false;
    }
    console.log('this.scaleCount  : '+ this.scaleCount );
    console.log('this.showScale  : '+ this.showScale );
    if (this.feedBackDescription === '' || this.feedBackDescription === ' ') {
      this.showDescription = true;
    }else{
      this.showDescription = false;
    }
    if (this.email === '' || this.email === ' ') {
      this.showEmail = true;
    }else{
      this.showEmail = false;
    }
    if (!this.validateEmail(this.email)) {
      this.showEmail = true;
    }else{
      this.showEmail = false;
    }
    
 

    if (!this.showScale && !this.showDescription && !this.showEmail) {

      if (parseInt(this.scaleCount) < 4) {
        this.scaleCount = this.scaleCount + ' (Not at all likely)';
      } else if (parseInt(this.scaleCount) >= 5 && parseInt(this.scaleCount) < 8) {
        this.scaleCount = this.scaleCount + ' (Netural)';
      } else if (parseInt(this.scaleCount) > 7) {
        this.scaleCount = this.scaleCount + ' (Extremely likely)';
      }

     this.apiService.submitFeedBack(this.scaleCount, this.feedBackDescription, this.email, this.contactPerson).subscribe();

      this.googleAnalyticsFunction('Email/Contact: '+this.email,'Feedback','Feedback',this.feedBackDescription,parseInt(this.scaleCount));
      amplitude.getInstance().logEvent("Feedback",{ "Email/Contact": this.email , "FeedBack Description" : this.feedBackDescription , "Scale Count" : this.scaleCount });

      (document.getElementById('desktopModal') as HTMLInputElement).style.display = 'none';

      (document.getElementById('submitModal') as HTMLInputElement).style.display = 'block';
      
      
      this.resetValues();
    } else {
      (document.getElementById('submitModal') as HTMLInputElement).style.display = 'none';
    }

  }

   //evtName: string, evtCategory: string, evtAction: string, evtLabel: string, evtValue: number
   googleAnalyticsFunction(actionName: string, evtCategory: string, eventName: string, eventLabel: string, evtValue: number) {

    this.googleAnalyticsService.eventEmitter(
      actionName,      //eventName -> Partner Help
      evtCategory,       //evtCategory ->Menu
      eventName,    //evtAction -> Resources
      eventLabel, //evtLabel -> Partner Help
      evtValue,           //evtValue
    );
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  selectScore(score: any) {
    console.log('Score : ' + score);
    this.scaleCount = score;
    this.toggle = !this.toggle;
    //console.log(this.toggle);
  }

  sideNavToggle(){
    this.menuStatus=!this.menuStatus;
    this.sideNavToggled.emit(this.menuStatus);
  }

  

}
